import { createSlice, createAsyncThunk, SerializedError } from '@reduxjs/toolkit';
import apiClient from '../api/apiClient';
import extractApiError from '../api/extractApiError';

interface IdentityChangeState {
  loading: boolean;
  error: SerializedError | string | null;
  success: boolean;
}

const initialState: IdentityChangeState = {
  loading: false,
  error: null,
  success: false,
};

// Interface برای داده‌های ارسالی به سرور
interface ChangeIdentityPayload {
  publisherId: string;
  contract: File;
  code: string;
}

// Async thunk برای ارسال کد تأیید
export const sendIdentityChangeOTP = createAsyncThunk(
  'identityChange/sendOTP',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiClient.post('/v2/publisher/changePublisherTypeSendCode');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(extractApiError(error, 'خطا در ارسال کد تأیید'));
    }
  }
);

// Async thunk برای تغییر هویت با کد تأیید
export const changeIdentityWithOTP = createAsyncThunk(
  'identityChange/changeWithOTP',
  async (payload: ChangeIdentityPayload, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append('publisher_id', payload.publisherId);
      formData.append('contract', payload.contract);
      formData.append('code', payload.code);

      const response = await apiClient.post(
        '/v2/publisher/changePublisherType',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(extractApiError(error, 'خطا در تغییر هویت'));
    }
  }
);

const identityChangeSlice = createSlice({
  name: 'identityChange',
  initialState,
  reducers: {
    resetIdentityChangeState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    // Send OTP
    builder.addCase(sendIdentityChangeOTP.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(sendIdentityChangeOTP.fulfilled, (state) => {
      state.loading = false;
      state.error = null;
    });
    builder.addCase(sendIdentityChangeOTP.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    });

    // Change Identity with OTP
    builder.addCase(changeIdentityWithOTP.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.success = false;
    });
    builder.addCase(changeIdentityWithOTP.fulfilled, (state) => {
      state.loading = false;
      state.error = null;
      state.success = true;
    });
    builder.addCase(changeIdentityWithOTP.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
      state.success = false;
    });
  },
});

export const { resetIdentityChangeState } = identityChangeSlice.actions;
export default identityChangeSlice.reducer;
